module.exports = __webpack_public_path__ + "img/tips_doctor.e052d334.png";